import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  notifyInvestorsTooltipContainer: {
    display: 'flex',
    gridGap: '.5rem',
    alignItems: 'center',
    marginRight: 15,
  },
  notifyInvestorsTooltip: {
    marginTop: 4,
    fontSize: 15,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    letterSpacing: 0,
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationColor: '#b0b0b0',
    textUnderlineOffset: '2px',
    color: theme.palette.text.darkBodyText,

    '& svg': {
      marginTop: -2,
      marginLeft: 4,
      marginRight: 8,
    },
  },
}));

export default useStyles;
